import { User } from '@/domains/models/User';
import { FavoriteList } from '@/domains/models/FavoriteList';

export type CampaignType = {
  _id: string;
  name: string;
  slug: string;
  _organization: string
}

export type CampaignTemplate = {
  key: string;
  name: string;
  campaignActions: CampaignAction[];
  // type: CampaignType;
}

export type CampaignAction = {
  _id: string;
  name: string;
  type: CampaignActionKey;
  subject: string;
  body: string;
  nextValidation: {
    operator: CampaignActionOperator;
    conditions: CampaignCondition[];
  };
}

export type CampaignProspectSourceKey =
  'CODER_LIST'
  | 'LINKEDIN_RECRUITER_PROJECT'
  | 'LINKEDIN_SEARCH'

export type CampaignProspectSource = {
  _id: string;
  type: CampaignProspectSourceKey;
  _list?: FavoriteList;
  recruiterProjectId?: string;
  searchUrl?: string;
  name: string;
  createdAt: Date;
  updatedAt: Date;
  prospectsCount: number;
}

export type ListProspectSource = CampaignProspectSource & {
  type: 'CODER_LIST';
  _list: string;
}

export type LinkedinRecruiterProjectProspectSource = CampaignProspectSource & {
  type: 'LINKEDIN_RECRUITER_PROJECT';
  recruiterProjectId: string;
}

export type CampaignProspectSourceDraft = Pick<CampaignProspectSource, 'type' | 'name' | Partial<'_list'>>

export type CampaignStatusKey =
  'ONGOING'
  | 'PAUSED'
  | 'INTERRUPTED'
  | 'DRAFT'
  | 'ARCHIVED'
  | 'FAILED'
  | 'FINISHED'
  | 'SCHEDULED'

export const campaignActionKeys = {
  LINKEDIN_MESSAGE: 'LINKEDIN_MESSAGE',
  LINKEDIN_INMAIL_SALES_NAVIGATOR: 'LINKEDIN_INMAIL_SALES_NAVIGATOR',
  LINKEDIN_INMAIL_RECRUITER: 'LINKEDIN_INMAIL_RECRUITER',
  LINKEDIN_INMAIL_PREMIUM: 'LINKEDIN_INMAIL_PREMIUM',
  LINKEDIN_INVITATION: 'LINKEDIN_INVITATION',
  LINKEDIN_PROFILE_VISIT: 'LINKEDIN_PROFILE_VISIT',
  LINKEDIN_VOICE_NOTE: 'LINKEDIN_VOICE_NOTE',
  SEND_MAIL: 'SEND_MAIL',
}
  
export type CampaignActionKey =
  'LINKEDIN_MESSAGE'
  | 'LINKEDIN_INMAIL_SALES_NAVIGATOR'
  | 'LINKEDIN_INMAIL_RECRUITER'
  | 'LINKEDIN_INMAIL_PREMIUM'
  | 'LINKEDIN_INVITATION'
  | 'LINKEDIN_PROFILE_VISIT'
  | 'LINKEDIN_VOICE_NOTE'
  | 'SEND_MAIL'

export type CampaignConditionKey =
'INVITATION_ACCEPTED'
| 'PROFILE_VISITED'
| 'DELAY'
| 'PROCESSED_CANDIDATE'
| 'MAIL_ANSWER'
| 'IMMEDIATELY_AFTER_STEP'
// | 'MESSAGE_RECEIVED'

export type CampaignActionOperator = 'AND' | 'OR'


export type DelayData = {
  days?: number;
  hours?: number;
  minutes?: number;
}


export type CampaignCondition = {
  conditionType: CampaignConditionKey;
  delay?: DelayData;
}

export type Campaign = {
  _id: string;
  name: string;
  isTemplate: boolean;
  _prospectsSources?: string[];
  prospectsSources: CampaignProspectSource[];
  prospectsCount: number;
  _coach: string;
  coach: User;
  _campaignTypes: string[];
  campaignTypes: CampaignType[];
  _organization: string;
  _actions: string[];
  actions: CampaignAction[];
  status: CampaignStatusKey;
  scheduledAt?: Date;
  startedAt?: Date;
  pausedAt?: Date;
  interruptedAt?: Date;
  interruptionReason?: string;
  archivedAt?: Date;
  createdAt: Date;
  updatedAt: Date;
}

export type CampaignProspectActionStatus = 'PENDING' | 'ONGOING' | 'EXECUTED' | 'COMPLETED' | 'FAILED'

export type CampaignProspectAction = {
  _campaignAction: string;
  triggered: Record<string, {triggeredAt: Date, conditionType: CampaignConditionKey}>;
  status: CampaignProspectActionStatus;
  executedAt?: Date;
  error?: {
    code?: string;
    message?: string;
    status?: number;
    title?: string;
  };
  failedAt?: Date;
  subject?: string;
  body?: string;
  _message?: string;
  campaignAction: CampaignAction;
  _scheduledTask?: string;
  _scheduledTasks?: string[];
  attachments?: any[];
}

export type CampaignProspectCoder = {
  _id: string;
  firstName: string;
  lastName: string;
  phone?: string;
  phones?: string[];
  email?: string;
  emails?: string[];
  title?: string;
  locations?: string[];
  pictureUrl?: string;
}

export type CampaignProspect = {
  _id: string;
  _coder: string;
  coder: CampaignProspectCoder;
  status: CampaignStatusKey;
  _campaign: string;
  campaign: Pick<Campaign, '_id' | 'name' | 'status'>;
  _prospectSources: string[];
  prospectSources: CampaignProspectSource[];
  prospectActions: CampaignProspectAction[];
  _currentAction?: string;
  createdAt: Date;
}
